"use client";
import { jsx as i } from "react/jsx-runtime";
import { COMPONENT_SIZES as a } from "../../common/constants/componentSizes.js";
import { ICON_SEVERITY as s } from "../../common/constants/iconSeverity.js";
import f from "../alert/Alert.js";
import d from "@emotion/styled";
import { COLORS as p } from "../../tokens/colors/Colors.js";
import { SIZES as e } from "../../tokens/sizes/Sizes.js";
import { forwardRef as l } from "react";
const c = l(
  ({ children: t, feSeverity: o, ...r }, m) => /* @__PURE__ */ i(
    n,
    {
      ...r,
      "data-comp": "toast",
      feIcon: s[o].iconAlias,
      feSeverity: o,
      ref: m,
      children: t
    }
  )
);
c.displayName = "Toast";
const n = d(f)`
	background: ${p.white};
	border-left-width: ${e.s08};
	width: ${a.toastWidth};
`;
export {
  c as default
};
